import React from 'react'

export function renderTraining(ctx) {
  const {
    activeTab,
    allProgress,
    assignModal,
    assignSelected,
    assignments,
    course,
    handleAddTraining,
    handleAssignCourse,
    handleDeleteTraining,
    handleUnassignCourse,
    lang,
    setActiveCourse,
    setAssignModal,
    setAssignSelected,
    setTrainingForm,
    t,
    toggleAssignWorker,
    training,
    trainingForm,
    trainingStatus,
    workers,
  } = ctx
  return (
    <>
          {activeTab === 'training' && (
            <div className="dash-section">
              <div className="dash-section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
                <div><h2>{t.trainingPrograms}</h2><p>{t.createAndManage}</p></div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  <button className="dash-btn secondary small" onClick={() => setActiveCourse({ id: 'default-logistics-1', title: 'Logistics & Supply Chain Certificate' })}>
                    🚚 Preview Logistics
                  </button>
                  <button className="dash-btn primary small" onClick={() => setActiveCourse({ id: 'english-1000h', title: 'English Language Certificate — 1 000 Hours' })}>
                    🇬🇧 Preview English Course
                  </button>
                  <button className="dash-btn secondary small" onClick={() => setActiveCourse({ id: 'leadership-16', title: '16 Leadership Principles' })}>
                    🦁 Preview Leadership
                  </button>
                </div>
              </div>

              {/* ── Training Progress Overview ── */}
              {allProgress.length > 0 && (
                <div className="dash-form-card" style={{ marginBottom: 20 }}>
                  <h3 style={{ marginBottom: 14 }}>📊 {lang === 'fr' ? 'Progression des employés' : 'Worker Training Progress'}</h3>
                  <div style={{ overflowX: 'auto' }}>
                    <table className="dash-table">
                      <thead>
                        <tr>
                          <th>{lang === 'fr' ? 'Employé' : 'Worker'}</th>
                          <th>{lang === 'fr' ? 'Cours' : 'Course'}</th>
                          <th style={{ width: 160 }}>{lang === 'fr' ? 'Progression' : 'Progress'}</th>
                          <th style={{ width: 60 }}>%</th>
                          <th>{lang === 'fr' ? 'Mis à jour' : 'Updated'}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allProgress.map(row => (
                          <tr key={`${row.worker_id}-${row.course_id}`}>
                            <td><strong>{row.worker_name || row.worker_id}</strong>{row.department && <span style={{ color: '#6b7280', fontSize: '0.8rem', marginLeft: 6 }}>({row.department})</span>}</td>
                            <td style={{ fontSize: '0.85rem' }}>{row.course_id === 'english-1000h' ? '🇬🇧 English 1000h' : row.course_id === 'default-logistics-1' ? '🚚 Logistics' : row.course_id === 'default-pmp-1' ? '📋 PMP' : row.course_id}</td>
                            <td>
                              <div style={{ height: 8, background: '#e5e7eb', borderRadius: 4, overflow: 'hidden' }}>
                                <div style={{ height: '100%', width: `${row.pct || 0}%`, background: (row.pct || 0) === 100 ? '#10b981' : '#3b82f6', borderRadius: 4, transition: 'width 0.3s' }} />
                              </div>
                            </td>
                            <td style={{ fontWeight: 600, color: (row.pct || 0) === 100 ? '#10b981' : '#3b82f6' }}>{row.pct || 0}%</td>
                            <td style={{ fontSize: '0.78rem', color: '#9ca3af' }}>{row.updated_at ? new Date(row.updated_at).toLocaleDateString() : '—'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              <div className="dash-form-card">
                <h3>{t.addNewCourse}</h3>
                <form className="dash-form" onSubmit={handleAddTraining}>
                  <div className="dash-form-row">
                    <label>{t.courseTitle} <span className="dash-required">*</span><input type="text" value={trainingForm.title} onChange={e => setTrainingForm(p => ({ ...p, title: e.target.value }))} placeholder="Logistics Safety Fundamentals" /></label>
                    <label>{t.duration}<input type="text" value={trainingForm.duration} onChange={e => setTrainingForm(p => ({ ...p, duration: e.target.value }))} placeholder="2 weeks / 8 hours" /></label>
                  </div>
                  <label>{t.category}
                    <select value={trainingForm.category} onChange={e => setTrainingForm(p => ({ ...p, category: e.target.value }))}>
                      <option value="logistics">Logistics</option>
                      <option value="technology">Technology</option>
                      <option value="safety">Safety</option>
                      <option value="management">Management</option>
                      <option value="compliance">Compliance</option>
                    </select>
                  </label>
                  <label>{t.description} <span className="dash-required">*</span><textarea rows="3" value={trainingForm.description} onChange={e => setTrainingForm(p => ({ ...p, description: e.target.value }))} placeholder="Describe this training..." /></label>
                  <div className="dash-form-actions">
                    <button className="dash-btn primary" type="submit">{t.addCourse}</button>
                    {trainingStatus && <span className="dash-status-msg">{trainingStatus}</span>}
                  </div>
                </form>
              </div>
              {training.length === 0 ? <div className="dash-empty-state"><span>🎓</span><p>{t.noCourses}</p></div> : (
                <div className="dash-training-grid">
                  {training.map(course => (
                    <div key={course.id} className="dash-training-card">
                      <div className="dash-training-card-header"><span className={`dash-cat-badge ${course.category}`}>{course.category}</span><button className="dash-delete-icon" onClick={() => handleDeleteTraining(course.id)}>×</button></div>
                      <h4 className="dash-training-title">{course.title}</h4>
                      <p className="dash-training-desc">{course.description}</p>
                      <div className="dash-training-meta"><span>⏱ {course.duration}</span><span>👥 {assignments.filter(a => (a.course_id ?? a.courseId) === course.id).length} assigned</span></div>
                      {/* Assign workers to course */}
                      <div className="dash-assign-section">
                        {assignModal === course.id ? (
                          <>
                            <p className="dash-assign-label">Select workers to enroll:</p>
                            <div className="dash-assign-checklist">
                              {workers.filter(w => w.status === 'active').length === 0 && (
                                <p style={{ color: 'var(--dash-muted)', fontSize: '0.82rem', margin: 0 }}>No active workers yet.</p>
                              )}
                              {workers.filter(w => w.status === 'active').map(w => {
                                const alreadyAssigned = !!assignments.find(a => (a.course_id ?? a.courseId) === course.id && String(a.worker_id ?? a.workerId) === String(w.id))
                                return (
                                  <label key={w.id} className={`dash-assign-check-row ${alreadyAssigned ? 'already' : ''}`}>
                                    <input
                                      type="checkbox"
                                      checked={assignSelected.has(w.id) || alreadyAssigned}
                                      disabled={alreadyAssigned}
                                      onChange={() => toggleAssignWorker(w.id)}
                                    />
                                    <span className="dash-assign-check-name">{w.name}</span>
                                    <span className="dash-assign-check-role">{w.role}</span>
                                    {alreadyAssigned && <span className="dash-assign-check-done">enrolled</span>}
                                  </label>
                                )
                              })}
                            </div>
                            <div className="dash-assign-actions">
                              <button
                                className="dash-btn primary small"
                                onClick={() => handleAssignCourse(course.id)}
                                disabled={!assignSelected.size}
                              >
                                Enroll {assignSelected.size > 0 ? `(${assignSelected.size})` : ''}
                              </button>
                              <button className="dash-btn secondary small" onClick={() => { setAssignModal(null); setAssignSelected(new Set()) }}>Cancel</button>
                            </div>
                          </>
                        ) : (
                          <button
                            className="dash-btn primary small"
                            onClick={() => { setAssignModal(course.id); setAssignSelected(new Set()) }}
                          >
                            + Enroll Workers
                          </button>
                        )}
                        {assignments.filter(a => (a.course_id ?? a.courseId) === course.id).length > 0 && (
                          <div className="dash-assigned-list">
                            {assignments.filter(a => (a.course_id ?? a.courseId) === course.id).map(a => {
                              const wId = a.worker_id ?? a.workerId
                              const w = workers.find(x => String(x.id) === String(wId))
                              if (!w) return null
                              const progRow = allProgress.find(p => String(p.worker_id) === String(wId) && p.course_id === course.id)
                              const pct = progRow ? (progRow.pct || 0) : 0
                              return (
                                <div key={a.id} className="dash-assigned-item">
                                  <span className="dash-assigned-name">{w.name}</span>
                                  <div className="dash-assigned-bar"><div style={{ width: `${pct}%`, height: '4px', background: pct === 100 ? '#10b981' : '#3b82f6', borderRadius: '2px' }} /></div>
                                  <span className="dash-assigned-pct">{pct}%</span>
                                  <button className="dash-delete-icon" onClick={() => handleUnassignCourse(a.id)} title="Remove">×</button>
                                </div>
                              )
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
    </>
  )
}
